import { render, staticRenderFns } from "./glLocalTable.vue?vue&type=template&id=22fb35cc"
import script from "./glLocalTable.vue?vue&type=script&lang=js"
export * from "./glLocalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports